var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#E6D6ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.5H20C17 16.5 15 18 15 21.5V28.5C15 32 17 33.5 20 33.5H30C33 33.5 35 32 35 28.5V21.5C35 18 33 16.5 30 16.5ZM30.47 22.59L27.34 25.09C26.68 25.62 25.84 25.88 25 25.88C24.16 25.88 23.31 25.62 22.66 25.09L19.53 22.59C19.21 22.33 19.16 21.85 19.41 21.53C19.67 21.21 20.14 21.15 20.46 21.41L23.59 23.91C24.35 24.52 25.64 24.52 26.4 23.91L29.53 21.41C29.85 21.15 30.33 21.2 30.58 21.53C30.84 21.85 30.79 22.33 30.47 22.59Z",
    fill: "#550080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMail);
export default __webpack_public_path__ + "static/media/new-mail.9b1b207776cd509ca1fc2788e810983f.svg";
export { ForwardRef as ReactComponent };